import React from 'react';
import { Lock, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Zero Liability Encryption Badge
 * Shows users their data is encrypted and we don't store it
 */
const EncryptionBadge = ({ variant = 'default', className = '' }) => {
  const { language } = useLanguage();
  
  const text = language === 'hi' 
    ? 'हम आपका डेटा स्टोर नहीं करते' 
    : "We don't store your data";
  
  const subtext = language === 'hi'
    ? 'आपके डिवाइस पर एन्क्रिप्टेड'
    : 'Encrypted on your device';

  if (variant === 'compact') {
    return (
      <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 bg-green-50 border border-green-200 rounded-full text-xs text-green-700 ${className}`}>
        <Lock className="h-3 w-3" />
        <span className="font-medium">{language === 'hi' ? 'एन्क्रिप्टेड' : 'Encrypted'}</span>
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <div className={`inline-flex items-center gap-2 text-xs text-green-600 ${className}`}>
        <Lock className="h-3.5 w-3.5" />
        <span>{text}</span>
      </div>
    );
  }

  // Default - full badge
  return (
    <div className={`flex items-center gap-3 p-3 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl ${className}`}>
      <div className="p-2 bg-green-100 rounded-lg">
        <ShieldCheck className="h-5 w-5 text-green-600" />
      </div>
      <div>
        <p className="text-sm font-semibold text-green-800 flex items-center gap-1.5">
          <Lock className="h-3.5 w-3.5" />
          {text}
        </p>
        <p className="text-xs text-green-600 mt-0.5">{subtext}</p>
      </div>
    </div>
  );
};

export default EncryptionBadge;
